$(document).ready(function(){

	bsBreakpoints.init();
	bsBreakpoints.detectBreakpoint();

	responsiveImages();

	$(window).on('init.bs.breakpoint',function(e){
		responsiveImages();
	});

	$('.video-container-desktop:hidden').remove();
	$('.video-container-desktop:visible').removeClass('d-none');
	$('.video-container-mobile:hidden').remove();
	$('.video-container-mobile:visible').removeClass('d-sm-none');

	$(window).on('new.bs.breakpoint',function(e){
		responsiveImages();
	});

	$('.hamburger').on('click', function(e){
		e.preventDefault();

		$('body').toggleClass('show-menu');
	});

	manageMobileSubmenus();

	$('#mobile-menu-main a').on('click', function(e){
		e.preventDefault();

		$('#mobile-menu-main li').removeClass('current-menu-item current-page-ancestor');
		$(this).closest('li').addClass('current-menu-item');
		manageMobileSubmenus();
	});

	$('.goto-content').on('click', function(e){
		e.preventDefault();

		$([document.documentElement, document.body]).animate({
			scrollTop: window.innerHeight
		}, 500);
	});

	const players = Plyr.setup('.plyr__video-embed:not(.with-controls)', {
		controls: ['play-large']
	});

	const playerWithControls = Plyr.setup('.plyr__video-embed.with-controls', {

	});

	estirar_imagenes();

	$(".contact-form").on('submit', function(e){
		e.preventDefault();

		const form = $(this);
		const messages = form.find('.messages');
		const btn = form.find('.btn.btn-primary');
		const btn_label = btn.html();

		let dots = 0;
		let ajax_form_data = form.serialize();

		btn.html('&nbsp;').attr('disabled', true);

		const interval = setInterval(btn_loading, 250);

		ajax_form_data = ajax_form_data + '&ajaxrequest=true&submit=Submit+Form';
		messages.html('');

		$.ajax({
			url:  '/wp-admin/admin-ajax.php',
			type: 'post',
			data: ajax_form_data
		}).done(function(response){
			const r = $.parseJSON(response);

			messages.html(r.message);

			if(r.status === 'success'){
				form.trigger("reset");
			}

			clearInterval(interval);
			btn.html(btn_label).attr('disabled', false);
		}).fail(function(){
			messages.html('<div class="alert alert-danger">Error</div>');
		});

		function btn_loading(){
			if(dots < 3){
				btn.append('&bull; ');
				dots++;
			}else{
				btn.html('&nbsp;');
				dots = 0;
			}
		}
	});

	$('.slider').each(function() {
		const slider = $(this);
		const sts = slider.closest('.slider').data('slides');
		
		slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			infinite: true,
			prevArrow: '<button type="button" class="slick-prev"><svg width="28" height="50" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.744 0.5C15.77 0.49998 15.7884 0.507972 15.799 0.515658L1.00946 14.1318L0.609959 14.4996L1.00943 14.8674L15.7974 28.4848C15.7867 28.4924 15.7687 28.5 15.7436 28.5C15.714 28.5 15.6943 28.4895 15.6848 28.4809L0.500456 14.5001L15.6849 0.519245C15.6849 0.519202 15.685 0.519159 15.685 0.519116C15.6945 0.510502 15.7143 0.500023 15.744 0.5ZM0.497409 14.4973L0.497328 14.4974L0.497502 14.4974L0.497409 14.4973Z" stroke="currentColor"/></svg></button>',
			nextArrow: '<button type="button" class="slick-next"><svg width="28" height="50" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.560666 28.5C0.534712 28.5 0.516254 28.492 0.505735 28.4843L15.2952 14.8682L15.6947 14.5004L15.2953 14.1326L0.507305 0.51518C0.517937 0.50759 0.535999 0.500001 0.561121 0.500001C0.590652 0.500001 0.610427 0.510489 0.619846 0.519134L15.8042 14.4999L0.619786 28.4808C0.619739 28.4808 0.619692 28.4808 0.619645 28.4809C0.610174 28.4895 0.59034 28.5 0.560666 28.5ZM15.8073 14.5027L15.8074 14.5026L15.8072 14.5026L15.8073 14.5027Z" fill="none" stroke="currentColor"/></svg></button>',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: sts || 2,
						slidesToScroll: 1
					}
				}
			]
		});
	});

	(function currencySlide(){
		const tickers = $(".ticker");

		tickers.each(function(i){
			const speed = $(tickers[i]).data('speed');
			const ul = $(tickers[i]).find("ul");
			const itemWidth = ul.find('li:first-child').outerWidth();

			if($(tickers[i]).hasClass('inverse')){
				ul.animate({marginRight: -itemWidth}, speed, 'linear', function(){
					$(this).css({marginRight: 0}).find("li:first").before($(this).find("li:last"));
				});
			}else{
				ul.animate({marginLeft: -itemWidth}, speed, 'linear', function(){
					$(this).css({marginLeft: 0}).find("li:last").after($(this).find("li:first"));
				});
			}
		});

		requestAnimationFrame(currencySlide);
	})();
});

window.onscroll = function(){ scrollFunction() };
window.onresize = function(){ resizeFunction() };

function scrollFunction(){
	if(document.body.scrollTop > 50 || document.documentElement.scrollTop > 50){
		document.body.classList.add('scrolled');
	}else{
		document.body.classList.remove('scrolled');
	}
}

function responsiveImages(){
	const bp = bsBreakpoints.getCurrentBreakpoint();

	if(bp === 'xSmall'){
		$('body').addClass('body-xs');
	}else{
		$('body').removeClass('body-xs');
	}

	$('.block-hero[data-desktop-bg]').each(function(){
		const that = $(this);

		if(bp === 'xSmall'){
			that.attr('style', 'background-image: url(' + that.data('mobile-bg') + ')');
		}else{
			that.attr('style', 'background-image: url(' + that.data('desktop-bg') + ')');
		}
	});
}

function resizeFunction(){
	estirar_imagenes();
}

function reveal(){
	gsap.set(".reveal", {y: 50});

	ScrollTrigger.batch('.reveal', {
		interval: 0.1,
		batchMax: 1,
		onEnter: batch => {
			gsap.to(batch, {duration: 1.25, opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 3]}, ease: "expo", overwrite: true, onComplete: function(){ batch.forEach(item => item.classList.remove('reveal')); }});
		},
	});

	ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".reveal", {y: 0}));
}

document.addEventListener("DOMContentLoaded", function(){
	gsap.registerPlugin(ScrollTrigger);
	reveal();
});

function manageMobileSubmenus(){
	if($('#mobile-menu-main li:last-child').is('.current-menu-item, .current-page-ancestor')){ //Pacientes
		$('.header-mobile .menu-profesionales-container').hide(100);
		$('.header-mobile .menu-pacientes-container').show(100);
	}else{ // Profesionales
		$('#mobile-menu-main li:first-child').addClass('current-menu-item');
		$('.header-mobile .menu-profesionales-container').show(100);
		$('.header-mobile .menu-pacientes-container').hide(100);
	}
}

function estirar_imagenes(){
	const xs = $('body').hasClass('body-xs');

	if(xs){
		const the_imagen = $('.page-block.block-imagen_mas_texto.estirar_imagen .the-imagen');
		const img = $('.page-block.block-imagen_mas_texto.estirar_imagen .the-imagen img');

		the_imagen.height('');
		img.height('');
		img.width('');
	}else{
		$('.page-block.block-imagen_mas_texto.estirar_imagen').each(function(i){
			const the_imagen = $(this).find('.the-imagen');
			const img = the_imagen.find('img');
			const w = $(window).width() / 2;
			const h = img.height();

			the_imagen.height(h);
			img.height(h);
			img.width(w);
		});
	}
}

/*
 * Bones Scripts File
 * Author: Eddie Machado
 *
 * This file should contain any js scripts you want to add to the site.
 * Instead of calling it in the header or throwing it inside wp_head()
 * this file will be called automatically in the footer so as not to
 * slow the page load.
 *
 * There are a lot of example functions and tools in here. If you don't
 * need any of it, just remove it. They are meant to be helpers and are
 * not required. It's your world baby, you can do whatever you want.
*/


/*
 * Get Viewport Dimensions
 * returns object with viewport dimensions to match css in width and height properties
 * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
*/
function updateViewportDimensions() {
	var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
	return { width:x,height:y };
}

// setting the viewport width
var viewport = updateViewportDimensions();

/*
 * Throttle Resize-triggered Events
 * Wrap your actions in this function to throttle the frequency of firing them off, for better performance, esp. on mobile.
 * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
*/
var waitForFinalEvent = (function () {
	var timers = {};

	return function (callback, ms, uniqueId) {
		if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
		if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 100;
